import { render, staticRenderFns } from "./StaffReport.vue?vue&type=template&id=c5fabcd0&scoped=true"
import script from "./StaffReport.vue?vue&type=script&lang=js"
export * from "./StaffReport.vue?vue&type=script&lang=js"
import style0 from "./StaffReport.vue?vue&type=style&index=0&id=c5fabcd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5fabcd0",
  null
  
)

export default component.exports